let handleType = (type) =>{
    let Type;
    switch (type) {
      case "1001":
        Type = "单选题";
        break;
      case "1002":
        Type = "多选题";
        break;
      case "1003":
        Type = "判断题";
        break;
      case "1004":
        Type = "简答题";
        break;
      case "1008":
        Type = "辨析题";
        break;
      case "1005":
        Type = "材料分析题";
        break;
      case "1006":
        Type = "写作题";
        break;
      case "1007":
        Type = "教学设计题";
        break;
      case "1009":
        Type = "活动设计题";
        break;
      case "1010":
        Type = "论述题";
        break;
      case "1011":
        Type = "名词解释题";
        break;
      case "1012":
        Type = "案例分析题";
        break; 
      case "1013":
        Type = "填空题";
        break; 
      case "1014":
        Type = "解答题";
        break;
      case "1015":
        Type = "概述题";
        break;
      case "1016":
        Type = "不定项选择题";
        break;
      default: 
        Type = "综合题";
        break;     
  } 
   return Type;
}
export default {
    "handleType":handleType
}